import { privateAxios } from '@/common/api/axios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseClientConsumptionsProps<T> = {
  filters?: {
    page?: number
    status?: string
    clientCompanyId?: string
    clientBranchId?: string
  }
  mapper?: (data: any) => T
}

export const useClientConsumptions = <T,>({
  filters: { page, status, clientCompanyId, clientBranchId } = {},
  mapper = Mapper.default<T>(),
}: UseClientConsumptionsProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['clientConsumptions', page, status, clientCompanyId, clientBranchId],
    queryFn: () => {
      return privateAxios.get('/client/consumptions', {
        params: {
          page,
          'q[status_eq]': status,
          'q[client_company_id_eq]': clientCompanyId,
          'q[client_branch_id_eq]': clientBranchId,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => ({
      data: mapper(data?.data?.data),
      meta: data?.data?.meta,
    }),
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
